import { categoryType, setState } from '@/commonTypes';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './styles.module.css';
import { useTranslations } from 'next-intl';
import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';
import Select from '@/components/common/Select';
import { useRouterPath } from '@/functions/routerPath';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import Filters from '@/components/general/Filters';
import MoreTagButton from './MoreTagButton';

export default function BlogsFiltersSection({
  category,
  totalCount,
  activeCategory = '',
  sortParams,
  setPageNumber,
  page = '/blogs',
  urlQuery = false,
  activeKey = 'slug',
  showSort = false,
  className = '',
  buttonClass = '',
  activeButtonClass = '',
  removeAllQuearies = true,
  queryKey = 'category',
}: {
  category?: categoryType[];
  totalCount?: number | string;
  activeCategory?: string | null;
  sortParams?: {
    sort?: string | null;
    orderBy?: string | null;
  };
  setPageNumber: setState<string | number>;
  page?: string;
  urlQuery?: boolean;
  activeKey: string;
  showSort?: boolean;
  className?: string;
  buttonClass?: string;
  activeButtonClass?: string;
  removeAllQuearies?: boolean;
  queryKey?: string;
}) {
  const tCommon = useTranslations('common');
  const router = useRouter();
  const routerPath = useRouterPath();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const [showMore, setShowMore] = useState(false);
  const sliceNumber = 4;

  const categoryList: any = category
    ? [{ id: '', slug: '', title: tCommon('all'), count: totalCount }]?.concat(
        showMore ? category : category?.slice(0, sliceNumber),
      )
    : [];
  const [filters, setFilters] = useState([
    { id: 1, params: { orderBy: 'created_at', sort: 'desc' }, title: tCommon('newest') },
    { id: 2, params: { orderBy: 'created_at', sort: 'asc' }, title: tCommon('oldest') },
    { id: 3, params: { orderBy: 'view_num', sort: 'desc' }, title: tCommon('mostViewed') },
    // {id:1, params:{orderBy:"createdAt", sort:"desc"}, title:"طولانی‌ترین"},
  ]);
  const [selectedFilter, setSelectedFilter] = useState(
    filters.find(
      (filter) =>
        filter.params.sort === sortParams?.sort && filter.params.orderBy === sortParams?.orderBy,
    ),
  );

  useEffect(() => {
    setSelectedFilter(
      filters.find(
        (filter) =>
          filter.params.sort === sortParams?.sort && filter.params.orderBy === sortParams?.orderBy,
      ),
    );
  }, [sortParams]);
  const type = activeCategory && activeCategory?.split(',')?.length > 1 ? 'multi' : 'single';
  const getCategoryHref = ({
    page,
    urlQuery,
    slug,
  }: {
    page: string;
    urlQuery?: boolean;
    slug?: string | null;
  }) => {
    const value = slug?.trim();

    // No existing query params
    if (!urlQuery) {
      return value ? `${page}/${queryKey}?name=${value}` : page;
    }

    // Existing query params
    const params = removeAllQuearies
      ? new URLSearchParams()
      : new URLSearchParams(searchParams.toString());

    if (value) {
      params.set(queryKey, value);
    } else {
      params.delete(queryKey);
    }
    params.set('page', '1');

    const query = params.toString();

    return query ? `${page}?${query}` : page;
  };

  console.log('activeCategory====', activeCategory);
  return (
    <section className={`${styles.filters_section} ${className}`} data-nav-theme="light">
      <div className={`${styles.filters}`}>
        <div className={`${styles.chips}`} role="tablist">
          {categoryList?.map((item: categoryType, index: number) => (
            <AppLink
              className={`${styles.chip} ${buttonClass} ${
                type == 'single'
                  ? activeCategory == item?.[activeKey as keyof categoryType] && styles.active
                  : activeCategory &&
                    activeCategory?.includes(item?.[activeKey as keyof categoryType]) &&
                    item?.[activeKey as keyof categoryType]?.trim()?.length != 0 &&
                    `${styles.active} ${activeButtonClass}`
              }`}
              key={index}
              // href={
              //   item?.slug?.trim()?.length != 0
              //     ? !urlQuery
              //       ? `${page}/category?name=${item?.slug}`
              //       : `${page}?category=${item?.slug}`
              //     : `${page}`
              // }
              href={getCategoryHref({
                page,
                urlQuery,
                slug: item?.slug,
              })}
            >
              {item?.title ? item?.title : item?.slug}
              {item?.count && <span className={`${styles.num}`}>{item?.count}</span>}
            </AppLink>
          ))}
          {/* {Number(category?.length) > sliceNumber + 1 && (
            <div className={`${styles.arrowIconContainer}`}>
              <MainIcons.ArrowIcon
                className={`${styles.arrowIcon} ${showMore && styles.rotateIcon}`}
                onClick={() => {
                  setShowMore(!showMore);
                }}
                fill="var(--text-mid)"
                width="20px"
                height="20px"
              />
            </div>
          )} */}
          <MoreTagButton
            list={category}
            sliceNumber={sliceNumber}
            showMore={showMore}
            setShowMore={setShowMore}
          />
        </div>
        {showSort && (
          <Filters
            setPageNumber={setPageNumber}
            sortParams={{
              sort: searchParams?.get('sort'),
              orderBy: searchParams?.get('orderBy'),
            }}
          />
        )}
      </div>
    </section>
  );
}
